import React, { useEffect, useState } from 'react';
import { ApplicationView, raw, useController } from '@aha-app/mvc';
import ObjectMenuController from './ObjectMenuController';
import styles from './objectMenuStyles.module.css';
import {
  iconDisplayName,
  iconTabItemStylusName,
  isIconTabItem,
  isShapeTabItem,
  searchResultItemComponent,
  searchResultItemDescription,
} from '../../utils/objectMenu';
import { svgToIcon } from '../../utils/svg';
import shapes from '../../assets/icons/shapesEmptyStateFilled.svg';
import { isFaIcon } from '../../utils/icons';
import classNames from 'classnames';
import { itemUniqueId } from './SearchManager';
import { isMenuItemDefinition } from '../../stylus/definitions';
import { type MenuStylus } from './ShapesTab';

const EmptyState: React.FC = () => (
  <div className={styles.objectMenuEmpty}>
    {svgToIcon(shapes)}
    <span className={styles.objectMenuEmptyTitle}>{`No shapes found`}</span>
    <span className={styles.objectMenuEmptySubtitle}>
      Change or remove the <br /> search term
    </span>
  </div>
);

interface SearchResultsProps {
  didScroll: boolean;
}

const SearchResults: React.FC<SearchResultsProps> = ({ didScroll }) => {
  const controller = useController(ObjectMenuController);
  const { searchResults } = controller.state;
  const { stylusIcon, stylusSpriteIcon } = controller.whiteboardController;
  const [previousStylus, setPreviousStylus] = useState(
    raw(controller.whiteboardController.state.currentStylus)
  );
  const [active, setActive] = useState('');

  useEffect(() => {
    // Clear the active state in the search menu if we change styluses (outside
    // of the search menu)
    if (
      previousStylus &&
      previousStylus !==
        raw(controller.whiteboardController.state.currentStylus)
    ) {
      setActive('');
    }
  }, [controller.whiteboardController.state.currentStylus, previousStylus]);

  if (searchResults.length === 0) {
    return <EmptyState />;
  }

  const results = didScroll ? searchResults : searchResults.slice(0, 100);

  return (
    <div>
      {results.map(item => {
        const name = isIconTabItem(item)
          ? iconDisplayName(item)
          : item.description?.();
        return (
          <div
            key={itemUniqueId(item)}
            className={classNames(styles.objectMenuSearchResult, {
              [styles.searchResultActive]: name === active,
            })}
            onClick={event => {
              let stylus: MenuStylus;

              if (isMenuItemDefinition(item)) {
                stylus = controller.whiteboardController.getStylus(
                  item.stylusDefinition
                );
              } else if (isShapeTabItem(item)) {
                stylus = item;
              } else {
                stylus = isFaIcon(item) ? stylusIcon : stylusSpriteIcon;
                stylus.options.iconName = iconTabItemStylusName(item);
              }

              setPreviousStylus(stylus);
              setActive(name);
              controller.actionCloseMenu(raw(stylus));
              event.stopPropagation();
            }}
          >
            <span className={styles.objectMenuSearchResultIcon}>
              {searchResultItemComponent(item)}
            </span>
            <span className={styles.objectMenuSearchResultText}>
              {searchResultItemDescription(item)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ApplicationView(SearchResults);
